/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getGraphicsPackage} from '../api'

 export const useQueryGetGraphicsPackage = createReactQueryHook('getGraphicsPackage', getGraphicsPackage)
